module.exports = __webpack_public_path__ + "static/furniture-support-info-section-8859c9f84987835145e169bbd7ed6a42.png";